export enum ContinuityEscrowRequestChangesRoutesEnum {
  Agreement = 'agreement',
  Beneficiary = 'beneficiary',
  Depositor = 'depositor',
  Technical = 'technical',
  Environment = 'environment',
}
